import React from "react";
import { DatePicker, Localization } from 'react-widgets';
import 'react-widgets/styles.css';
import {connect} from "react-redux";
import moment from "moment";
import MomentLocalizer from 'react-widgets-moment';
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import {blurInput, checkDateIsTillToday, checkDateValidity} from "../../lib/utils";
import store from "../../store";
import {toggleSearchTransactionsPopover} from "../../actions/userActions";
import AmountRange from "./AmountRange";
import SearchBox from "../common/SearchBox";
import Tooltip from "../common/Tooltip";

const Translate = require('react-redux-i18n').Translate;

const I18n = require('react-redux-i18n').I18n;

const stateMap = (store) => {
    return {
        i18n: store.i18n,
        userReducer: store.userReducer,
        merchantReducer: store.merchantReducer
    };
};

class CardlessPopoverSearch extends React.Component {
    constructor(props) {
        super(props)

        let midsWithNoLocation = this.getMidsFormats(props, false);
        let midsInDropdownFormat = this.getMidsFormats(props, true);

        this.state = {
            fromPlaceholder: I18n.t("pages.transactions.searchModal.midColumn.from"),
            toPlaceholder: I18n.t("pages.transactions.searchModal.midColumn.to"),
            transactionDateFrom: this.props.data.dateFrom ? moment(this.props.data.dateFrom, 'DD/MM/YYYY').toDate() : moment().toDate(),
            transactionTimeFrom: this.props.data.startTime ? moment(this.props.data.startTime, "HH:mm A").toDate() : moment("00:00", "HH:mm A").toDate(),
            transactionDateTo: this.props.data.dateTo ? moment(this.props.data.dateTo, 'DD/MM/YYYY').toDate() : moment().toDate(),
            transactionTimeTo: this.props.data.endTime ? moment(this.props.data.endTime, "HH:mm A").toDate() : moment("23:59", "HH:mm A").toDate(),
            amountFrom: this.props.data.amountFrom || this.props.data.amountFrom === 0 ? this.props.data.amountFrom : '',
            amountTo: this.props.data.amountTo || this.props.data.amountTo === 0 ? this.props.data.amountTo : '',
            source: this.props.data && this.props.data.source ? this.props.data.source : '',
            sourceLabel: this.props.data && this.props.data.sourceLabel ? this.props.data.sourceLabel : I18n.t('pages.transactions.searchModal.cardless.allSourcesLabel'),
            paymentRespMessage: this.props.data && this.props.data.paymentRespMessage ? this.props.data.paymentRespMessage : '',
            paymentRespMsgLabel: this.props.data && this.props.data.paymentRespMsgLabel ? this.props.data.paymentRespMsgLabel : I18n.t('pages.transactions.searchModal.cardless.allPaymentRespMsgsLabel'),
            moreCriteria: false,
            singleAfmMid: this.props.userReducer.getAssociationsResponse.merchantType === 'singleAfmMid',
            maxDateRange: process.env.SEARCH_LIMIT_DAYS_SMALL,
            // DatePicker open state control
            dateFromIsOpen: false,
            dateToIsOpen: false,
            allMids: midsInDropdownFormat ? false : true,
            pickedMids: midsWithNoLocation ? midsWithNoLocation : null,
            pickedMidsAfterDisabled: undefined,
        };

        this.handleChange = this.handleChange.bind(this)
        this.handleFormattedChange = this.handleFormattedChange.bind(this)
        this.resetSearchToDefault = this.resetSearchToDefault.bind(this)
        this.changeDateFrom = this.changeDateFrom.bind(this)
        this.changeDateTo = this.changeDateTo.bind(this)
        this.checkDateChangeRestrictions = this.checkDateChangeRestrictions.bind(this)
        this.nullifyAmountToIfAmountFromGreater = this.nullifyAmountToIfAmountFromGreater.bind(this)
        this.nullifyAmountToIfItIs0 = this.nullifyAmountToIfItIs0.bind(this)
        this.getSourceOptions = this.getSourceOptions.bind(this)
        this.getPaymentRespMsgOptions = this.getPaymentRespMsgOptions.bind(this)
        this.combineDateAndTime = this.combineDateAndTime.bind(this)
        this.splitDateAndTime = this.splitDateAndTime.bind(this)
        this.handleDateFromOpen = this.handleDateFromOpen.bind(this)
        this.handleDateToOpen = this.handleDateToOpen.bind(this)
        this.getMidsFormats = this.getMidsFormats.bind(this)
        this.formAllMidsValues = this.formAllMidsValues.bind(this)
    }

    // Helper method to combine separate date and time into single Date object
    combineDateAndTime(date, time) {
        if (!date || !time) return date;
        const combined = moment(date);
        const timeOnly = moment(time);
        combined.hour(timeOnly.hour());
        combined.minute(timeOnly.minute());
        combined.second(timeOnly.second());
        return combined.toDate();
    }

    // Helper method to split combined Date object back to separate date and time
    splitDateAndTime(combinedDate) {
        if (!combinedDate) return { date: null, time: null };
        const date = moment(combinedDate).startOf('day').toDate();
        const time = moment(combinedDate).toDate();
        return { date, time };
    }

    // Handler for DateFrom open state
    handleDateFromOpen(isOpen) {
        // Only close if user is intentionally closing (clicking outside, pressing Escape, etc.)
        this.setState({ dateFromIsOpen: isOpen });
    }

    // Handler for DateTo open state
    handleDateToOpen(isOpen) {
        // Only close if user is intentionally closing (clicking outside, pressing Escape, etc.)
        this.setState({ dateToIsOpen: isOpen });
    }

    componentWillMount() {
        let midsNum = (this.props.data.nonMapData && this.props.data.nonMapData.midsInDropdownFormat || []).length;
        
        this.setState({
            maxDateRange: midsNum > parseInt(process.env.SEARCH_LIMIT_MIDS) ? parseInt(process.env.SEARCH_LIMIT_DAYS_SMALL) : parseInt(process.env.SEARCH_LIMIT_DAYS_BIG)
        });
    }

    resetSearchToDefault() {
        const defaultSourceLabel = I18n.t('pages.transactions.searchModal.cardless.allSourcesLabel');
        const defaultPaymentRespMsgLabel = I18n.t('pages.transactions.searchModal.cardless.allPaymentRespMsgsLabel');

        this.setState({
            transactionDateFrom: moment().toDate(),
            transactionTimeFrom: moment("00:00", "HH:mm").toDate(),
            transactionDateTo: moment().toDate(),
            transactionTimeTo: moment("23:59", "HH:mm").toDate(),
            amountFrom: '',
            amountTo: '',
            source: '',
            sourceLabel: defaultSourceLabel,
            paymentRespMessage: '',
            paymentRespMsgLabel: defaultPaymentRespMsgLabel,
            // Reset DatePicker open states
            dateFromIsOpen: false,
            dateToIsOpen: false,
            allMids: true,
            pickedMids: null,
        });
        
        // Update parent state as well
        if (this.props.data && this.props.data.handleChange) {
            this.props.data.handleChange('source', '');
            this.props.data.handleChange('sourceLabel', defaultSourceLabel);
        }
    }

    getMidsFormats(props, dropdown) {
        if (props.data.merchantId && props.nonMapData && props.nonMapData.midsInDropdownFormat) {
            const splittedMids = props.data.merchantId.split(',');
            let midsInDropdownFormat = splittedMids.map(mid => {
                return props.nonMapData.midsInDropdownFormat.find(obj => obj && obj.value === mid);
            }).filter(Boolean); // Remove any undefined entries

            if (dropdown) {
                return midsInDropdownFormat;
            } else {
                return midsInDropdownFormat.map(element => {
                    return {value: element.value, label: element.value};
                });
            }
        }
        return null;
    }

    formAllMidsValues() {
        let pickedMids;

        if (!this.state.allMids && this.state.pickedMids) {
            const allMidsValues = this.state.pickedMids.map(pickedMid => {
                return pickedMid.value;
            });
            pickedMids = allMidsValues.join();
        } else {
            pickedMids = undefined;
        }

        return pickedMids;
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.i18n.locale !== this.props.i18n.locale) {
            this.setState({
                fromPlaceholder: I18n.t("pages.transactions.searchModal.midColumn.from"),
                toPlaceholder: I18n.t("pages.transactions.searchModal.midColumn.to")
            })
        }

        if (nextProps.isToggleOn !== this.props.isToggleOn && !nextProps.isToggleOn) {
            // No need to manually hide in Bootstrap 5 as rootClose handles this
            store.dispatch(toggleSearchTransactionsPopover(false));
        }
        
        // Update source and sourceLabel when parent state changes
        if (nextProps.data && this.props.data && (
            nextProps.data.source !== this.props.data.source ||
            nextProps.data.sourceLabel !== this.props.data.sourceLabel
        )) {
            this.setState({
                source: nextProps.data.source || '',
                sourceLabel: nextProps.data.sourceLabel || I18n.t('pages.transactions.searchModal.cardless.allSourcesLabel')
            });
        }

        // Handle MID dropdown updates when company changes - update maxDateRange based on MID count
        if (nextProps.data && nextProps.data.nonMapData && this.props.data && this.props.data.nonMapData &&
            nextProps.data.nonMapData.midsInDropdownFormat !== this.props.data.nonMapData.midsInDropdownFormat) {
            const midsDropdownFormat = nextProps.data.nonMapData.midsInDropdownFormat || [];
            
            // Update maxDateRange based on new MID count (same logic as PopoverSearch.js)
            const midsNum = midsDropdownFormat.length;
            const newMaxDateRange = midsNum > parseInt(process.env.SEARCH_LIMIT_MIDS) ? 
                parseInt(process.env.SEARCH_LIMIT_DAYS_SMALL) : 
                parseInt(process.env.SEARCH_LIMIT_DAYS_BIG);
            
            this.setState({
                maxDateRange: newMaxDateRange
            });
        }
    }

    handleChange(event) {
        // Handle both regular form inputs and dropdown selections
        if (event.object) {
            // Handle dropdown selection (similar to PopoverSearch.js)
            const stateUpdate = {
                [event.id]: event.object.value,
                [event.label]: event.object.label
            };

            this.setState(stateUpdate);
            
            // Update parent state for source and sourceLabel
            if (event.id === 'source' && this.props.data && this.props.data.handleChange) {
                this.props.data.handleChange('source', event.object.value);
                this.props.data.handleChange('sourceLabel', event.object.label);
            }
        } else if (event.target.type === "checkbox") {
            this.setState({
                [event.target.id]: event.target.checked,
            }, () => {
                if (this.state.allMids) {
                    this.props.setSelectedMid(undefined);
                    this.setState({
                        pickedMidsAfterDisabled: this.state.pickedMids,
                        pickedMids: null
                    });
                } else if (this.state.pickedMidsAfterDisabled) {
                    this.props.setSelectedMid(this.state.pickedMidsAfterDisabled.map(a => a.value));
                    this.setState({
                        pickedMids: this.state.pickedMidsAfterDisabled,
                        pickedMidsAfterDisabled: null
                    });
                }
            });
        } else {
            // Handle regular form inputs
            this.setState({
                [event.target.id]: event.target.value
            });
        }
    }

    handleFormattedChange(obj, ev) {
        this.setState({
            [ev.target.id]: obj.floatValue
        })
    }

    changeDateFrom(transactionDateFrom) {
        let days = this.state.maxDateRange;
        if (this.checkDateChangeRestrictions(transactionDateFrom)) {
            const dateFromPlusXDays = moment(transactionDateFrom).add(days, 'days').toDate();
            let dateTo = moment(this.state.transactionDateTo).toDate();
            if (moment(dateFromPlusXDays).isBefore(moment(dateTo))) {
                dateTo = moment(transactionDateFrom).add(days, 'days').toDate();
            } else if (moment(transactionDateFrom).isAfter(moment(this.state.transactionDateTo))) {
                dateTo = moment(transactionDateFrom).toDate();
            }
            this.setState({
                transactionDateFrom: transactionDateFrom,
                transactionDateTo: dateTo
            });
        } else {
            this.setState({
                transactionDateFrom: moment().subtract(days, 'days').toDate()
            });
        }
    }

    changeDateTo(transactionDateTo) {
        let days = this.state.maxDateRange;
        if (this.checkDateChangeRestrictions(transactionDateTo)) {
            let dateFrom = moment(this.state.transactionDateFrom).toDate();
            const dateFromPlusXDays = moment(this.state.transactionDateFrom).add(days, 'days');
            if (moment(transactionDateTo).isAfter(dateFromPlusXDays)) {
                dateFrom = moment(transactionDateTo).subtract(days, 'days').toDate();
            } else if (moment(transactionDateTo).isBefore(moment(this.state.transactionDateFrom))) {
                dateFrom = moment(transactionDateTo).toDate();
            }
            this.setState({
                transactionDateFrom: dateFrom,
                transactionDateTo: transactionDateTo
            });
        } else {
            this.setState({
                transactionDateTo: moment().toDate()
            });
        }
    }

    checkDateChangeRestrictions(date) {
        return checkDateValidity(date) && checkDateIsTillToday(date)
    }

    nullifyAmountToIfAmountFromGreater(amountFrom, amountTo) {
        if (amountFrom > amountTo) {
            amountTo = undefined
        }

        return {amountFrom: amountFrom, amountTo: amountTo}
    }

    nullifyAmountToIfItIs0(amountTo) {
        return amountTo === 0 ? undefined : amountTo
    }

    getSourceOptions() {
        const defaultOption = {
            value: '', 
            label: I18n.t('pages.transactions.searchModal.cardless.allSourcesLabel'),
            key: '0_all'
        };

        if (this.props.data.allMaps && this.props.data.allMaps.cardless && this.props.data.allMaps.cardless.source) {
            return [defaultOption, ...this.props.data.allMaps.cardless.source];
        }

        return [defaultOption];
    }

    getPaymentRespMsgOptions() {
        const defaultOption =  {
            value: '',
            label: I18n.t('pages.transactions.searchModal.cardless.allPaymentRespMsgsLabel'),
            key: '0_ALLSTATUSES'
        };

        if (this.props.data.allMaps && this.props.data.allMaps.cardless && this.props.data.allMaps.cardless.status) {
            const statusObj = this.props.data.allMaps.cardless.status;
            const entries = Object.entries(statusObj).map(([index, data]) => ({
                value: String(index),
                label: I18n.t(`pages.cardless.details.statusDescription.${index}`),
                key: `${index}_${data.ecomStatus}`
            }));

            return [defaultOption, ...entries];
        }

        return [defaultOption];
    }

    render() {
        const baseTranslate = "pages.transactions.searchModal";
        const currency = "€";
        const locale = I18n._locale;
        const nonMapData = this.props.nonMapData;

        // Set up moment locale for Greek AM/PM translation
        const currentLocale = locale === 'el' ? 'el' : 'en-GB';
        moment.locale(currentLocale);

        // Configure Greek locale if needed (for AM/PM translation ΠΜ/ΜΜ)
        if (currentLocale === 'el') {
            moment.updateLocale('el', {
                meridiem: function (hour, minute, isLower) {
                    if (hour < 12) {
                        return isLower ? 'πμ' : 'ΠΜ';
                    } else {
                        return isLower ? 'μμ' : 'ΜΜ';
                    }
                }
            });
        }
          const momentLocalizer = new MomentLocalizer(moment);

        // Set format based on locale - comma for Greek, space for English
        const dateTimeFormat = currentLocale === 'el' ? "DD/MM/YYYY, HH:mm" : "DD/MM/YYYY HH:mm";

        // Combine date and time for DatePicker components
        const combinedDateTimeFrom = this.combineDateAndTime(
            this.state.transactionDateFrom,
            this.state.transactionTimeFrom
        );
        const combinedDateTimeTo = this.combineDateAndTime(
            this.state.transactionDateTo,
            this.state.transactionTimeTo
        );

        return (
            <Localization date={momentLocalizer}>
                <div className="overall-search-modal">
                    <button className="overall-search-modal__button-container__reset-link"
                            onClick={this.resetSearchToDefault}>
                        <Translate value="pages.transactions.searchModal.labels.clear"/>
                    </button>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        const pickedMids = this.formAllMidsValues();
                        let {amountFrom, amountTo} = this.nullifyAmountToIfAmountFromGreater(this.state.amountFrom,
                            this.state.amountTo)
                        amountTo = this.nullifyAmountToIfItIs0(amountTo)
                        
                        // Update parent state with current search values
                        if (this.props.data && this.props.data.handleChange) {
                            this.props.data.handleChange('source', this.state.source);
                            this.props.data.handleChange('sourceLabel', this.state.sourceLabel);
                            this.props.data.handleChange('paymentRespMessage', this.state.paymentRespMessage);
                            this.props.data.handleChange('paymentRespMsgLabel', this.state.paymentRespMsgLabel);
                            this.props.data.handleChange('amountFrom', amountFrom);
                            this.props.data.handleChange('amountTo', amountTo);
                        }
                        
                        this.props.getTransactions(this.state.transactionDateFrom, this.state.transactionDateTo,
                            this.state.transactionTimeFrom, this.state.transactionTimeTo,
                            amountFrom, amountTo, this.state.source, pickedMids, this.state.paymentRespMessage, 1, this.props.rowsPerPage, true, undefined, undefined);
                        this.props.resetPopover();
                    }}>
                        <div className="search-modal">
                            <div className="search-modal__left-column-upper search-modal__column">
                                <Translate value={baseTranslate + ".leftColumn.timePeriod"}/>
                                {/* Transaction Date + Time From */}
                                <div className="datepicker__wrapper">
                                    <div className="datepicker__label">
                                        <Translate value={baseTranslate + ".leftColumn.from"}/>
                                    </div>
                                    <DatePicker
                                        value={combinedDateTimeFrom}
                                        includeTime={true}
                                        step={30}
                                        valueDisplayFormat={dateTimeFormat}
                                        valueEditFormat={dateTimeFormat}
                                        open={this.state.dateFromIsOpen}
                                        onToggle={this.handleDateFromOpen}
                                        autoFocus={false}
                                        onChange={(combinedDateTime) => {
                                            if (combinedDateTime) {
                                                const {date, time} = this.splitDateAndTime(combinedDateTime);

                                                // Check if the date changed (not just time) to decide whether to close
                                                const dateChanged = !moment(date).isSame(moment(this.state.transactionDateFrom), 'day');

                                                this.setState({
                                                    transactionDateFrom: date,
                                                    transactionTimeFrom: time,
                                                    // Close only if date was selected from calendar, not if only time was edited
                                                    dateFromIsOpen: !dateChanged
                                                });
                                                // Apply existing date validation logic
                                                this.changeDateFrom(date);
                                            } else {
                                                // Handle clear button - reset ONLY TIME to 00:00, keep existing date
                                                this.setState({
                                                    transactionTimeFrom: moment("00:00", "HH:mm").toDate()
                                                });
                                            }
                                        }}
                                        onKeyDown={(event) => {
                                            // Close DatePicker when user presses Enter
                                            if (event.key === 'Enter') {
                                                this.setState({dateFromIsOpen: false});
                                            }
                                        }}
                                        max={moment().toDate()}
                                    />
                                </div>
                                {/* Transaction Date + Time To */}
                                <div className="datepicker__wrapper">
                                    <div className="datepicker__label">
                                        <Translate value={baseTranslate + ".leftColumn.to"}/>
                                    </div>
                                    <DatePicker
                                        value={combinedDateTimeTo}
                                        includeTime={true}
                                        step={30}
                                        valueDisplayFormat={dateTimeFormat}
                                        valueEditFormat={dateTimeFormat}
                                        open={this.state.dateToIsOpen}
                                        onToggle={this.handleDateToOpen}
                                        autoFocus={false}
                                        onChange={(combinedDateTime) => {
                                            if (combinedDateTime) {
                                                const {date, time} = this.splitDateAndTime(combinedDateTime);

                                                // Check if the date changed (not just time) to decide whether to close
                                                const dateChanged = !moment(date).isSame(moment(this.state.transactionDateTo), 'day');

                                                this.setState({
                                                    transactionDateTo: date,
                                                    transactionTimeTo: time,
                                                    // Close only if date was selected from calendar, not if only time was edited
                                                    dateToIsOpen: !dateChanged
                                                });
                                                // Apply existing date validation logic
                                                this.changeDateTo(date);
                                            } else {
                                                // Handle clear button - reset ONLY TIME to 23:59, keep existing date
                                                this.setState({
                                                    transactionTimeTo: moment("23:59", "HH:mm").toDate()
                                                });
                                            }
                                        }}
                                        onKeyDown={(event) => {
                                            // Close DatePicker when user presses Enter
                                            if (event.key === 'Enter') {
                                                this.setState({dateToIsOpen: false});
                                            }
                                        }}
                                        max={moment().toDate()}
                                    />
                                </div>
                                <AmountRange
                                    baseTranslate={baseTranslate}
                                    handleFormattedChange={this.handleFormattedChange}
                                    fromPlaceholder={this.state.fromPlaceholder}
                                    toPlaceholder={this.state.toPlaceholder}
                                    amountFrom={this.state.amountFrom}
                                    amountTo={this.state.amountTo}
                                    currency={currency}
                                    clsType={'left'}
                                />

                                {/* Source dropdown */}
                                <div className="search-modal__field--source">
                                    <Translate value="pages.transactions.searchModal.cardless.source"/>
                                    <ButtonToolbar>
                                        <DropdownButton
                                            className="search-modal__single-column__dropdowns no-multi"
                                            title={this.state.sourceLabel ?
                                                this.state.sourceLabel :
                                                <Translate value={baseTranslate + ".cardless.allSourcesLabel"}/>}
                                            id="dropdown-source">
                                            {this.getSourceOptions().map(option => (
                                                <Dropdown.Item
                                                    eventKey={option.value}
                                                    key={option.key}
                                                    onClick={() => {
                                                        this.handleChange({
                                                            id: 'source',
                                                            object: option,
                                                            label: 'sourceLabel'
                                                        });
                                                    }}
                                                    active={option.value === this.state.source}>
                                                    {option.label}
                                                </Dropdown.Item>
                                            ))}
                                        </DropdownButton>
                                    </ButtonToolbar>
                                </div>
                            </div>
                            <div className="search-modal__right-column-upper search-modal__column">
                                {!this.state.singleAfmMid ?
                                    <div className="search-modal__field--mid">
                                        <p className="transactions-allmids-cbox">
                                    <span className="transactions-allmids-cbox__wrapper">
                                       <input type="checkbox"
                                              name="select-allMids-checkbox"
                                              id="allMids"
                                              checked={this.state.allMids}
                                              onChange={(event) => {
                                                  this.handleChange(event);
                                              }}
                                       />
                                        <label htmlFor={'allMids'}>
                                            <Translate value={baseTranslate + ".midColumn.toAllStores"}/>
                                        </label>
                                    </span>
                                        </p>
                                        <div className="search-modal__mid-column-upper__mids-search-wrapper">
                                            <SearchBox options={nonMapData.midsInDropdownFormat || []}
                                                       key={`mids-searchbox-${(nonMapData.midsInDropdownFormat || []).length}`}
                                                       blurBox={this.state.allMids}
                                                       blurInput={blurInput}
                                                       clsName="transactions-allmids-select"
                                                       value={this.state.pickedMids}
                                                       onChange={(event) => {
                                                           if (event.length > 0) {
                                                               const midsOnly = event.map(element => {
                                                                   return {value: element.value, label: element.value};
                                                               });
                                                               this.setState({
                                                                   pickedMids: midsOnly,
                                                               }, () => {
                                                                   this.props.setSelectedMid(this.state.pickedMids.map(a => a.value));
                                                               });
                                                           } else {
                                                               this.setState({
                                                                   pickedMids: null,
                                                                   allMids: true
                                                               });
                                                               this.props.setSelectedMid(null);
                                                           }
                                                       }}
                                                       placeholder={baseTranslate + ".midColumn.toSpecificStores"}
                                                       isMulti={true}
                                                       isDisabled={this.state.allMids}/>
                                            <div className="transactions__tooltip-wrapper">
                                                <Tooltip placement="bottom"
                                                         tooltipButtonId="trxSearchMultipleMID"
                                                         popoverId="multiple-mid-popover-tltp"
                                                         tooltipLabelClass="multiple-mid-transaction-label"
                                                         tooltipText="trxSearchMultipleMID"
                                                />
                                            </div>
                                        </div>
                                    </div> : null}
                                <div className="search-modal__field--status">
                                    <Translate value={baseTranslate + ".rightColumn.transStatus"}/>
                                    <ButtonToolbar>
                                        <DropdownButton
                                            className="search-modal__single-column__dropdowns no-multi"
                                            title={this.state.paymentRespMsgLabel ?
                                                (<span className="dropdown-title">{this.state.paymentRespMsgLabel}</span>) :
                                                <Translate
                                                    value={baseTranslate + ".cardless.allPaymentRespMsgsLabel"}/>}
                                                    id="dropdown-payment-resp-msg">
                                                    {this.getPaymentRespMsgOptions().map(option => (
                                                        <Dropdown.Item
                                                            eventKey={option.value}
                                                            key={option.key}
                                                            onClick={() => {
                                                                this.handleChange({
                                                                    id: 'paymentRespMessage',
                                                                    object: option,
                                                                    label: 'paymentRespMsgLabel'
                                                                });
                                                            }}
                                                            active={option.value === this.state.paymentRespMessage}>
                                                            {option.label}
                                                        </Dropdown.Item>
                                                    ))}
                                        </DropdownButton>
                                    </ButtonToolbar>
                                </div>
                            </div>
                        </div>
                        <div className="overall-search-modal__button-container">
                        <button type="submit" className="overall-search-modal__search-button">
                                <Translate value="pages.transactions.searchModal.labels.opened"/>
                            </button>
                        </div>
                    </form>
                </div>
            </Localization>
        )
    }
}

export default connect(stateMap)(CardlessPopoverSearch);
